/**
 * Timing Constants
 *
 * Centralized timing values for the softphone module.
 * Avoids magic numbers scattered throughout the codebase.
 */

/**
 * Delay in milliseconds before cleaning up a terminated call.
 * This small delay ensures all state updates are processed before removal.
 */
export const CALL_CLEANUP_DELAY_MS = 100;

/**
 * Delay in milliseconds before reconnecting after cleanup.
 * Allows cleanup to complete before re-initializing SIP connection.
 */
export const RECONNECT_DELAY_MS = 500;

/**
 * Delay in milliseconds to wait after stopping UserAgent before proceeding.
 * Allows SIP.js library to properly close connections and clean up internal state.
 */
export const USER_AGENT_STOP_DELAY_MS = 500;

/**
 * ICE gathering timeout in milliseconds.
 * Reduced to minimize audio connection delay.
 */
export const ICE_GATHERING_TIMEOUT_MS = 200;

/**
 * ICE checking timeout in milliseconds.
 * Reduced to minimize audio connection delay.
 */
export const ICE_CHECKING_TIMEOUT_MS = 500;

/**
 * WebSocket connection timeout in seconds.
 */
export const TRANSPORT_OPTIONS_CONNECTION_TIMEOUT_SEC = 12;

/**
 * WebSocket reconnection timeout in seconds.
 */
export const TRANSPORT_OPTIONS_RECONNECTION_TIMEOUT_SEC = 12;

/**
 * Maximum number of WebSocket reconnection attempts.
 */
export const TRANSPORT_OPTIONS_MAX_RECONNECTION_ATTEMPTS = 6;

/**
 * Interval in milliseconds between second incoming call chime repeats.
 * Legacy behavior: chime plays, then repeats every 10 seconds.
 */
export const SECOND_INCOMING_CALL_INTERVAL_MS = 10000;

/**
 * Hover delay in milliseconds before a softphone call-action tooltip opens.
 * Keeps the shortcut hints from flashing while the pointer crosses the
 * action bar on the way to another button.
 */
export const TOOLTIP_DELAY_MS = 500;
